window.arClientVerifiedFormatter = function(value, row) {
    let html = '';
    html += value;
    if (row.client_verified === 1) {
        html += '<i class="fal fa-check-circle fa-2xs text-success ms-1" title="'+__('Verified')+'"></i>';
    }
    return html;
}
